import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { ChartContainer, ChartTooltip, ChartTooltipContent } from '@/components/ui/chart';
import { CustomTooltip } from './CustomTooltip';

interface OnlineUsersChartProps {
  data: { date: string; count: number }[];
}

export const OnlineUsersChart = ({ data }: OnlineUsersChartProps) => {
  const chartConfig = {
    count: {
      label: 'Usuários Ativos',
      color: 'hsl(142.1 76.2% 36.3%)',
    },
  };

  return (
    <ChartContainer config={chartConfig} className="h-[300px] w-full">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" className="stroke-muted" />
          <XAxis
            dataKey="date"
            tick={{ fontSize: 12 }}
            tickFormatter={(value) => {
              const date = new Date(value);
              return `${date.getDate()}/${date.getMonth() + 1}`;
            }}
          />
          <YAxis tick={{ fontSize: 12 }} />
          <Tooltip content={<CustomTooltip />} />
          <Line
            type="monotone"
            dataKey="count"
            stroke="hsl(142.1 76.2% 36.3%)"
            strokeWidth={2}
            dot={{ fill: 'hsl(142.1 76.2% 36.3%)' }}
            animationDuration={800}
            animationEasing="ease-in-out"
          />
        </LineChart>
      </ResponsiveContainer>
    </ChartContainer>
  );
};
